export default {
  'PARTICIPANT' (state) {
    return state.participant
  }
}
